import { Box } from "flux";
import { CSSProperties, ReactNode } from "react";
import { AspectRatio } from "../../types/aspect-ratios";
import { ASPECT_RATIO_CSS_VALUES } from "../../constants/aspect-ratios";

export interface OverlayImageProps {
  baseImage: ReactNode;
  overlayImage: string;
  alt?: string;
  width?: number | string;
  height?: number | string;
  overlayStyle?: CSSProperties;
  displayOverlay?: boolean;
  aspectRatio?: AspectRatio;
}
// Use standardized aspect ratio values
const aspectRatioValues = ASPECT_RATIO_CSS_VALUES;

// Style for the base image container
const baseImageContainerStyle: CSSProperties = {
  width: "100%",
  height: "100%",
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden"
};

// Style to ensure base image properly fills the container based on aspect ratio
const baseImageWrapperStyle: CSSProperties = {
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};
export const OverlayImage = ({
  baseImage,
  overlayImage,
  alt = "",
  width,
  height,
  overlayStyle,
  displayOverlay = false,
  aspectRatio = "square"
}: OverlayImageProps) => {
  // Apply aspect ratio to container
  const containerStyle: CSSProperties = {
    aspectRatio: aspectRatioValues[aspectRatio],
    width: "100%",
    height: "100%",
    position: "relative",
    overflow: "hidden"
  };

  const overlayImageStyle: CSSProperties = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "contain",
    zIndex: 1, // Ensure overlay is above the base image
    ...overlayStyle
  };

  return (
    <Box position="relative" display="inline-block" width={width} height={height}>
      <Box style={containerStyle}>
        <Box style={baseImageContainerStyle}>
          <Box style={baseImageWrapperStyle}>{baseImage}</Box>
        </Box>
        {displayOverlay && <img src={overlayImage} alt={`${alt} overlay`} style={overlayImageStyle} />}
      </Box>
    </Box>
  );
};
